var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar bg-color-green d-flex justify-content-center align-items-center"},[_c('h4',{staticClass:"h4 m-0 font-bold text-uppercase"},[_vm._v(_vm._s(_vm.formatText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }